import Vue from 'vue'
import App from './App.vue'
import './filters'
import router from "./router"
import '../public/js/flexble.js'
import store from './store';
import { Capacitor } from '@capacitor/core';
import { applyProvisionalSafeArea, applyNativeSafeArea, setupSafeAreaListeners } from '@/utils/safeArea';
import { hasPrivacyAgreement } from '@/utils/privacyConsent';

import './assets/css/reset.css';
import 'vant/lib/index.less';
import './styles/global.scss';

// iOS分享兼容性修复
// import { IOSShareFix } from '@/utils/iosShareFix';
// 页面标题管理工具
import titleManager from '@/utils/titleManager';
// Android 性能优化
// import { androidPerformanceOptimizer } from '@/utils/androidPerformanceOptimizer';

// import eventLib from '@/utils/documentEvent.js';
// window.$_EventLib = eventLib;
// 滑动验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
//音视频播放
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import "vue-video-player/src/custom-theme.css";

Vue.use(VideoPlayer)

import AlleyUI from "./lib"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import { Toast } from 'vant'
Vue.use(Toast)
Vue.use(Vant);
Vue.use(AlleyUI);
Vue.use(titleManager);
// 引入环境检测插件
import { EnvPlugin } from '@/utils/env-detector'
// 使用插件
Vue.use(EnvPlugin)


// 裁切
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
// 滑片
import "swiper/css/swiper.min.css"
import { swiper, swiperSlide } from 'vue-awesome-swiper';
Vue.component('Swiper', swiper);
Vue.component('SwiperSlide', swiperSlide);
// 瀑布流
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry)

import globalMixin from '../src/mixins/lineHeightMixin.js';
Vue.mixin(globalMixin); // 引入全局混入

import global from '@/mixins/index.js'
Vue.mixin(global)
import wx from 'weixin-js-sdk';
// Push 初始化暂时禁用（iOS JPush 未配置时会导致链接/运行错误）
// import { initPush } from '@/utils/push';
import authService from '@/utils/authService';
import { getAccountHomePath } from '@/utils/launchRoute';
import { initPushNavigation } from '@/utils/pushNavigation';
import { setPushNavigationRouter } from '@/utils/push';

Vue.prototype.$wx = wx;

// 将iOS分享修复工具添加到Vue原型中
// Vue.prototype.$IOSShareFix = IOSShareFix;

// 在这里添加全局变量
Vue.prototype.$globalCloseImage = require('@/assets/image/closeIcon.png');

// Vue.directive('line-height', lineHeightDirective);

// import Vconsole from 'vconsole'; //移动端调试工具
//   // 打包后隐藏
// if (process.env.NODE_ENV == 'development') {
//   const vConsole = new Vconsole();
//   Vue.use(vConsole);
// }

// 创建事件总线
Vue.prototype.bus = new Vue()

Vue.config.productionTip = false

// 原生安全区：仅做 CSS 兜底，不调用 Device API；完整安全区在用户同意隐私政策后再应用
try {
  if (Capacitor.isNativePlatform()) {
    applyProvisionalSafeArea();
    setupSafeAreaListeners();
    if (hasPrivacyAgreement()) {
      applyNativeSafeArea().catch((e) => {
        console.warn('[safe-area] applyNativeSafeArea failed', e);
      });
    }
  }
} catch (e) {
  console.warn('[safe-area] setup error', e);
}

async function bootstrapNativeAuthState() {
  window.__XPZ_RUN_MOUNTED_AUTO_LOGIN__ = true;

  try {
    if (!authService.isAutoLoginEnabled()) {
      return false;
    }

    // 未同意隐私政策前不恢复登录态，避免同意前触发网络/SDK 初始化
    if (Capacitor.isNativePlatform() && !hasPrivacyAgreement()) {
      return false;
    }

    const restored = await store.dispatch('loadAuthFromStorage');
    if (restored) {
      const userInfo = authService.getUserInfo();
      if (userInfo) {
        try {
          const compatUserInfo = Object.assign({}, userInfo, {
            access_token: store.getters.accessToken
          });
          sessionStorage.setItem('userInfoXpz', JSON.stringify(compatUserInfo));
          sessionStorage.setItem('accountTypeXpz', JSON.stringify(userInfo.accountType));
        } catch (error) {
          console.warn('[Bootstrap] Failed to sync auth state into sessionStorage:', error);
        }
      }
      window.__XPZ_RUN_MOUNTED_AUTO_LOGIN__ = false;
      console.log('[Bootstrap] Restored native auth state before app mount');
    }
    return restored;
  } catch (error) {
    console.warn('[Bootstrap] Failed to preload native auth state:', error);
    return false;
  }
}

async function bootstrapApp() {
  await bootstrapNativeAuthState();

  setPushNavigationRouter(router);
  initPushNavigation(router);

  new Vue({
    router,
    store,
    render: h => h(App),
    async mounted() {
    // 应用启动时进行iOS优化
    // IOSShareFix.optimizeForIOS();

    // 只在原生App中启用自动登录，且用户已同意隐私政策
    const privacyAgreed = hasPrivacyAgreement();
    if (authService.isAutoLoginEnabled() && privacyAgreed && window.__XPZ_RUN_MOUNTED_AUTO_LOGIN__ === true) {
      // 尝试自动登录
      try {
        const autoLoginSuccess = await authService.tryAutoLogin();
        if (autoLoginSuccess) {
          console.log('[AutoLogin] 自动登录成功');
          try {
            console.log('[AutoLogin] post-login location:', window.location.href, window.location.hash);
            console.log('[AutoLogin] post-login localStorage xpzAuthData:', localStorage.getItem('xpzAuthData'));
            console.log('[AutoLogin] post-login sessionStorage userInfoXpz:', sessionStorage.getItem('userInfoXpz'));
          } catch (e) {
            console.warn('[AutoLogin] post-login inspect failed:', e);
          }

          // 如果当前是登录页或根路径，自动导航到角色对应首页（冷启动场景）
          try {
            const userInfo = authService.getUserInfo() || {};
            const accountType = userInfo.accountType || authService.getAccountType();
            const currentHash = (window.location.hash || '').replace(/^#/, '');

            // Only attempt redirect when at root or login pages
            if (!currentHash || currentHash === '/' || currentHash.startsWith('/login') || currentHash.startsWith('/verifyLogin')) {
              // helper to try SPA navigation
              const trySpaNavigate = async (path) => {
                try {
                  await Vue.nextTick();
                  // small delay to reduce race conditions
                  await new Promise(r => setTimeout(r, 30));
                  await this.$router.replace({ path });
                  return true;
                } catch (err) {
                  return false;
                }
              };

              if (accountType) {
                const targetPath = getAccountHomePath(userInfo, accountType);
                console.log('[AutoLogin] attempting SPA navigate to', targetPath, 'for accountType', accountType);
                const ok = await trySpaNavigate(targetPath);
                if (!ok) {
                  console.warn('[AutoLogin] SPA navigate failed, falling back to hard redirect', targetPath);
                  window.location.href = window.location.origin + '/#' + targetPath;
                }
              }
            } else {
              console.log('[AutoLogin] currentHash not root/login, skipping auto-redirect:', currentHash);
            }
          } catch (e) {
            console.warn('[AutoLogin] auto-redirect failed:', e);
          }
        } else {
          console.log('[AutoLogin] 自动登录失败，用户需要手动登录');
        }
      } catch (error) {
        console.error('[AutoLogin] 自动登录过程中发生错误:', error);
      }
    } else if (!authService.isAutoLoginEnabled()) {
      console.log('[AutoLogin] 免登功能仅在原生App中启用，当前为浏览器环境');
    }

    // 初始化推送服务
    // 说明：
    // - 首次启动且用户尚未同意隐私政策时，不初始化推送，避免在同意前获取设备标识（如 ANDROID_ID）
    // - 如果用户之前已经同意过隐私政策（本地有标记），则可以在启动时直接初始化推送
    // - 用户首次同意隐私政策时，会在 App.vue 的 handleAgree 中再次调用 initPush
    try {
      if (hasPrivacyAgreement()) {
        const { initPush, syncNativePrivacyConsent, ensurePushTokenBound } = await import('@/utils/push');
        syncNativePrivacyConsent(true);
        await initPush();
        await ensurePushTokenBound('main-bootstrap');
        console.log('[Main] Push service initialized successfully (user had agreed privacy policy)');
      } else {
        console.log('[Main] User has not agreed privacy policy yet, skip push initialization on startup');
      }
    } catch (e) {
      console.warn('[Main] Push init failed (expected in emulator or before agreement):', e);
    }

    // 初始化 Android 性能优化
    // androidPerformanceOptimizer.init();

    // 注销已存在的 Service Worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
          registration.unregister().then(success => {
            if (success) {
              console.log('[SW] Service Worker 已注销');
            }
          });
        }
      });
    }
    }
  }).$mount('#app');
}

bootstrapApp();
